/* eslint-disable camelcase */
import dutchMessages from 'ra-language-dutch'
import { StringMap } from 'react-admin'

export const i18nDutch: StringMap = {
  ...dutchMessages,
  dashboard: {
    greeting: {
      morning: 'Goedemorgen',
      afternoon: 'Goedemiddag',
      evening: 'Goedenavond',
    },
    description: 'Welkom bij xxllnc Klantcontact.',
    descriptionAdmin: 'Welkom bij xxllnc Klantcontact.',
  },
  resources: {
    conversation: {
      name: 'Gesprek |||| Gesprekken',
      list: 'Gesprekken',
      edit: 'Gesprek bewerken',
      fields: {
        channel: 'Kanaal',
        status: 'Status',
        subject: 'Onderwerp',
        contact_name: 'Contact',
        employee_email: 'Medewerker',
        created: 'Aangemaakt',
        notes: 'Notities',
      },
    },
    employees: {
      list: 'Medewerkers',
      show: {
        title: 'Medewerker Details',
        calls: 'Toegewezen Gesprekken',
        noCalls: 'Geen gesprekken.',
      },
    },
  },
  filters: {
    title: 'Filters',
    status: 'Status',
  },
  data: {
    name: 'Naam',
    description: 'Omschrijving',
    owner: 'Eigenaar',
    ownerHelperText: 'Vul hier het (xxllnc) mail adres van de eigenaar van het project in.',
    url: 'De url van het project in Labs (https://[project_name].labs.xxllnc.nl)',
    created: 'Gemaakt op',
    contributors: 'Betrokkenen',
    contributorsText: 'Vul hier de (xxllnc) mail adressen in van de collegas die aan het project hebben gewerkt.',
    tags: 'Tags',
  },
  login: {
    title: 'Inloggen',
    button: 'Inloggen',
    choose: 'Kies voor welke organisatie je wilt inloggen:',
    email: 'Email',
    emailHint: 'Vul je emailadres in om door te gaan.',
    fetchUserInfo: 'Een moment geduld, we halen je gebruikersinformatie op.',
    hint: 'Log in op xxllnc Klantcontact',
    incognitoError: 'Authenticatie niet mogelijk in incognito mode',
    loginCompleted: 'Succesvol ingelogd!',
    unknownOrganizationId: 'Het opgegeven organisatie-id is onbekend',
    notValid: 'Het opgegeven emailadres is niet geldig',
    byXxllnc: 'Klantcontact is een applicatie van xxllnc',
    inactive: 'Je bent uitgelogd vanwege inactiviteit.',
  },
  page: {
    unauthorized: {
      headerTitle: 'Onbevoegd',
      defaultTitle: 'Onbevoegd',
      title: 'Voor deze actie ben je niet bevoegd.',
      text: 'Je hebt geprobeerd een actie uit te voeren waar je geen rechten voor hebt.',
    },
  },
  submenu: {
    settings: 'Beheer',
  },
}
